import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { IFileService } from 'vscode/vscode/vs/platform/files/common/files.service';
import { IRemoteAgentService } from 'vscode/vscode/vs/workbench/services/remote/common/remoteAgentService.service';
import { IWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/common/environmentService.service';
import { IUriIdentityService } from 'vscode/vscode/vs/platform/uriIdentity/common/uriIdentity.service';
import { ILabelService } from 'vscode/vscode/vs/platform/label/common/label.service';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';
import { IConfigurationService } from 'vscode/vscode/vs/platform/configuration/common/configuration.service';
import { WorkingCopyHistoryService } from '../common/workingCopyHistoryService.js';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';

let BrowserWorkingCopyHistoryService = class BrowserWorkingCopyHistoryService extends WorkingCopyHistoryService {
    constructor(fileService, remoteAgentService, environmentService, uriIdentityService, labelService, logService, configurationService) {
        super(fileService, remoteAgentService, environmentService, uriIdentityService, labelService, logService, configurationService);
    }
    getModelOptions() {
        return { flushOnChange: true  };
    }
};
BrowserWorkingCopyHistoryService = ( __decorate([
    ( __param(0, IFileService)),
    ( __param(1, IRemoteAgentService)),
    ( __param(2, IWorkbenchEnvironmentService)),
    ( __param(3, IUriIdentityService)),
    ( __param(4, ILabelService)),
    ( __param(5, ILogService)),
    ( __param(6, IConfigurationService))
], BrowserWorkingCopyHistoryService));

export { BrowserWorkingCopyHistoryService };
